module.exports = __webpack_public_path__ + "static/img/4216_phase_function_Paper_Points.2215012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4216_phase_function_Paper_Points.png
// module id = Bm2k
// module chunks = 0